import { atom } from "recoil"

export const allMemberImageUrlsRequestIdState = atom({
  key: "atoms/resource/allMemberImageUrlsRequestIdState",
  default: 0,
})
